import React from 'react'
import { observer } from 'mobx-react-lite'

// evertel
import { Row } from '@evertel/web/ui'
import { MessageBodyProps } from './MessageBody'

const EventMessageBody: React.FC<MessageBodyProps> = observer(({
    message
}) => {

    const eventType = (message.meta as { eventType: string })?.eventType

    // Map event type to border-left color (CSS variable)
    // Default is var(--bs-muted) from the .event-message-inlay class
    let borderColor: string | undefined
    switch (eventType) {
        case 'thread_started':
        case 'connector_enabled':
            borderColor = 'var(--bs-success)'
            break
        case 'screen_shot':
        case 'document_removed':
        case 'connector_disabled':
            borderColor = 'var(--bs-danger)'
            break
        case 'updated_room_settings':
            // default muted border — no override needed
            break
        // Stale — API no longer emits these event types
        // case 'member_added':
        // case 'manager_added':
        // case 'member_removed':
        // case 'manager_removed':
        // case 'bulletin_added':
        // case 'bulletin_updated':
        // case 'bulletin_removed':
        default:
            break
    }

    // Urgent messages always get danger border
    if (message?.isUrgent) {
        borderColor = 'var(--bs-danger)'
    }

    // Format text — bold "enabled"/"disabled" for integration events
    let displayText = message?.text || ''
    if (eventType === 'connector_enabled' || eventType === 'connector_disabled') {
        displayText = displayText.replace(/(enabled|disabled)/gi, '<strong>$1</strong>')
    }

    return (
        <Row
            className="event-message-inlay"
            style={borderColor ? { borderLeftColor: borderColor } : undefined}
        >
            <div
                dangerouslySetInnerHTML={{ __html: displayText }}
                className="post-content"
            />
        </Row>
    )
})

EventMessageBody.displayName = 'EventMessageBody'

export { EventMessageBody }
